import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NewsService } from '../services/news.service';
import { Router } from '@angular/router';
import { CustomDataService } from '../services/custom-data.service';


@Component({
  selector: 'hot-topic',
  templateUrl: './hot-topic.component.html',
  styleUrls: ['./hot-topic.component.css']
})
export class HotTopicComponent implements OnInit {

  allNews; 
  @Output()change = new EventEmitter();
  constructor(private news:NewsService , private router:Router ) {
    this.allNews = this.news.newsData ;
   }

  ngOnInit() {
  }
 

}
